export default __webpack_public_path__ + "static/media/netflix_logo.774e8c16.png";